import React from 'react';
import Image from './Image';
import { toTitleCase } from '../../utilities/String';

const Container = props => (
    <div className="space-y-4">
        <figure className="overflow-hidden rounded-3xl border border-slate-200 bg-slate-50 p-4 shadow-inner">
            <Image card={props.card} />
        </figure>
        <div className="rounded-2xl border border-slate-200 bg-slate-50 shadow-sm">
            <div className="space-y-5 p-4 sm:p-5">
                <div className="flex flex-wrap items-center gap-2">
                    <h5 className="grow text-2xl font-semibold text-slate-900">{toTitleCase(props.card.name)}</h5>
                </div>

                <div className="space-y-3">
                    <h6 className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
                        Fortune
                    </h6>
                    <div className="space-y-2 text-slate-700">
                        {props.renderList(props.card.fortune_telling)}
                    </div>
                </div>
                <div className="space-y-2">
                    <h6 className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
                        Keywords
                    </h6>
                    <div className="flex flex-wrap gap-2">
                        {props.renderBadges(props.card.keywords)}
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Container;